export default __webpack_public_path__ + "static/media/rasindeinterview.7a034870.png";